export default {
    out: (el) => {
        return new Promise((resolve) => {
            setInterval(function fade() {
                if (!el.style.opacity) {
                    el.style.opacity = "1";
                }
                if (parseFloat(el.style.opacity) > 0) {
                    el.style.opacity = (parseFloat(el.style.opacity) - 0.1).toString();
                }
                else {
                    clearInterval();
                    resolve(undefined);
                }
            }, 50);
        });
    },
    in: (el, display) => {
        return new Promise((resolve) => {
            el.style.display = display || "block";
            setInterval(function fade() {
                var _a;
                let val = parseFloat((_a = el.style.opacity) !== null && _a !== void 0 ? _a : "0");
                if (!((val += 0.1) > 1)) {
                    el.style.opacity = val.toString();
                    requestAnimationFrame(fade);
                    resolve(undefined);
                }
            }, 50);
        });
    },
};
